import { render, staticRenderFns } from "./EmergencyRecordManage.vue?vue&type=template&id=5798aa93&scoped=true&"
import script from "./EmergencyRecordManage.vue?vue&type=script&lang=js&"
export * from "./EmergencyRecordManage.vue?vue&type=script&lang=js&"
import style0 from "./EmergencyRecordManage.vue?vue&type=style&index=0&id=5798aa93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5798aa93",
  null
  
)

export default component.exports